import React, { useState } from "react";
import { RCCButton, RCCHookToast, RCCServicesApi, RCCTooltip } from "react-common-components";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import AppIcons from "../AppIcons";
import ReportGroupers from "./interface";
import reportsButton from "./styles";

const Reports: React.FC<{ grouper:  ReportGroupers}> = ({
	grouper
}) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const { checkIfHasSpecificPermission, superUser, administrator } = useAuth();	

	const [loading, setLoading] = useState(false);

	const hasPermission =  superUser || administrator || checkIfHasSpecificPermission("reports/panel", PermissionEnum.VIEW);

	const handleClickButton = async () => {
		setLoading(true);
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: "reports/ListGroupers"
			});
			const idClicked = data.findIndex((item: any) => item === grouper);
			if(idClicked !== -1)
				window.open(`/reports/panel/${idClicked}`, "_blank");	
			setLoading(false);
		}catch(err: any){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar abrir relatórios"), addToast);
		}
	};

	return(
		<>
			{hasPermission ? (
				<RCCTooltip
					text={translate("Relatórios")}
					color="grey"
				>
					<RCCButton
						color="grey"
						layout="isRounded"
						size="md"
						onClick={handleClickButton}
						styleInline={reportsButton}
						loading={loading}
					>
						<AppIcons
							size={18} 
							name="reports" 
						/>
					</RCCButton>
				</RCCTooltip>
			) : null}
		</>
	);
};

export default Reports;
